<script setup lang="ts">
import CompulsoryModal from '../comp/CompulsoryModal.vue';
import useLogic from '../hooks/useLogic';
import VButton from '@/components/second/Button/index.vue';
import InstallProgress from '@/pwa/comp/InstallProgress.vue';
const {
      pwaLaunchAllow,
      pwaAllow,
      os,
      isShelfPackage,
      installStatus,
      btnText,
      isInstallAPK,
      isPwa,
      installProgress,
      wakeUpApk,
      openChrome,
      launchCheck,
      installCheck,
      downLoadTodo,
      pullUpPwaHomeBar,
      onlineServiceHandle
} = useLogic()
const wrapFn = (cb: () => void) => {
      copyTextAppendEL.value = 'compulsory-warp'
      cb()
} 
</script>
<template>
      <CompulsoryModal>
            <template #install-area>
                  <!-- 客服 -->
                  <div @click="onlineServiceHandle"
                        class="support flex items-center justify-center h-[2.5rem] w-[2.5rem] mr-[1.8125rem]"><ion-icon
                              class="text-[1.75rem]" src="/svg/serivce.svg" /></div>
                  <!-- 安装/启动按钮 -->
                  <VButton mode="md" class="flex-1 text-white" shape="round" v-if="isShelfPackage" @click="openChrome">
                        <button class="w-full h-full btn-text">{{ $t('components.progressierOperation4')
                              }}</button>
                  </VButton>
                  <VButton mode="md" class="flex-1 text-white" shape="round"
                        v-else-if="isInstallAPK && installStatus !== 'Installing'" @click="wakeUpApk">
                        <button class="w-full h-full btn-text">{{ $t('viewsSystem.install')
                              }}</button>
                  </VButton>
                  <template v-else-if="installStatus === 'NotInstall' || os === 'DesktopOS'">
                        <VButton mode="md" class="flex-1 text-white" shape="round" v-if="pwaLaunchAllow"
                              @click="pullUpPwaHomeBar">
                              <button class="w-full h-full btn-text">{{
                                    $t('label.launchApp') }}</button>

                        </VButton>
                        <VButton mode="md" class="flex-1 text-white" shape="round" v-else-if="pwaAllow"
                              @click="wrapFn(installCheck)">
                              <button class="w-full h-full btn-text">{{
                                    $t('viewsSystem.install') }}</button>
                        </VButton>
                        <VButton mode="md" class="flex-1 text-white" shape="round" v-else @click="wrapFn(downLoadTodo)">
                              <button class="w-full h-full btn-text">{{ btnText }}</button>
                        </VButton>

                  </template>
                  <!-- 安装进度条 -->
                  <InstallProgress v-else-if="installStatus === 'Installing' && (os === 'AndroidH5' || isPwa)"
                        :value="installProgress" />
                  <VButton mode="md" class="flex-1 text-white" shape="round"
                        v-if="installStatus === 'Installed' && os === 'AndroidH5'" @click="pullUpPwaHomeBar">
                        <button class="w-full h-full btn-text">{{
                              $t('label.launchApp') }}</button>

                  </VButton>


            </template>
            <template #tipIcon>
                  <ion-icon class="text-[.8125rem] " src="/svg/download/tip-2.svg" />

            </template>

      </CompulsoryModal>
</template>

<style scoped lang="less">
:deep(.amber-purple) {
      .header {
            background: url('/images/bg-forced-popup-amber-BR.png');
            background-size: 100%;
      }
      .header-BR {
            background: url('/images/bg-forced-popup-amber-BR.png');
            background-size: 100%;
      }
      .header-PH {
            background: url('/images/bg-forced-popup-amber-PH.png');
            background-size: 100%;
      }

      background-color: var(--color-bg-300);

      .title {
            color: var(--text-color-light-purple-1-100);
      }

      p {
            color: var(--text-color-light-purple-2-100);
      }

      span {
            color: var(--accent-color-yellow);
      }

      .logo {
            background-color: var(--color-bg-100);

            p {
                  color: var(--text-color-light-purple-1-100);
            }
      }

      .support {
            border-width: 1px;
            border-style: solid;
            border-radius: 0.5rem;

            border-color: var(--line-color);
            background: var(--color-bg-200);
            box-shadow: 0px 4px 6.8px 0px rgba(0, 0, 0, 0.25), 0px -2px 4px 0px rgba(0, 0, 0, 0.11) inset;
      }

      .tip-box {
            span {
                  color: var(--text-color-light-purple-2-100);
            }
      }

      .warn {
            background-color: var(--color-bg-100);
      }

      .btn-text {
            color: var(--color-primary-btn-text-active);
      }

}
</style>
